import { Product, VideoDetails } from '@news-mono/web-common'
import React from 'react'
import { PlayButton } from '../../../../buttons/PlayButton/PlayButton'
import {
    StyledAutoplayWrap,
    StyledCancel,
    StyledCountdown,
    StyledCountdownTime,
    StyledHeading,
    StyledInset,
    StyledTitleOverlay,
    StyledTitles,
    StyledVideoDuration,
    StyledVideoMetadata,
} from '../../../../content/Video/components/TitleOverlay/TitleOverlay.styled'
import { useProduct } from '../../../../__product/useProduct'
import { ThemedRender } from '../../../../__styling/themed-render'
export interface TitleOverlayProps {
    videoDetails: VideoDetails
    videoDuration?: string
    autoplayRemainingTime?: number
    compactMode: boolean
    showVideoTitle?: boolean
    play: () => void
    cancelAutoplay: () => void
}

export const TitleOverlay: React.FC<TitleOverlayProps> = ({
    videoDuration,
    videoDetails,
    play,
    autoplayRemainingTime,
    cancelAutoplay,
    compactMode,
    showVideoTitle: showVideoTitle,
}) => {
    const isCountingDown = autoplayRemainingTime !== undefined
    const product = useProduct()

    return (
        <ThemedRender
            sevennews={() => (
                <StyledTitleOverlay compactMode={compactMode}>
                    <StyledInset>
                        <StyledTitles>
                            <StyledHeading
                                title={videoDetails.heading}
                                autoPlayIsEnabled={isCountingDown}
                                showVideoTitle={showVideoTitle}
                            >
                                {videoDetails.heading}
                                {showVideoTitle && videoDuration && (
                                    <StyledVideoDuration>
                                        {videoDuration}
                                    </StyledVideoDuration>
                                )}
                            </StyledHeading>
                            {!compactMode && (
                                <StyledVideoMetadata
                                    duration={videoDuration}
                                    source={videoDetails.source}
                                    type={videoDetails.videoType}
                                />
                            )}
                        </StyledTitles>
                        {isCountingDown && (
                            <StyledAutoplayWrap>
                                <StyledCountdown>
                                    Video will play in{' '}
                                    <StyledCountdownTime>
                                        {autoplayRemainingTime}
                                    </StyledCountdownTime>
                                    ..
                                </StyledCountdown>
                                <StyledCancel
                                    className="video-js__autoplay-control"
                                    type="button"
                                    onClick={cancelAutoplay}
                                >
                                    Don't play video
                                </StyledCancel>
                            </StyledAutoplayWrap>
                        )}
                    </StyledInset>
                </StyledTitleOverlay>
            )}
            fallback={() => (
                <StyledTitleOverlay compactMode={compactMode}>
                    <PlayButton
                        onClick={play}
                        isCentered={false}
                        isInversed={product !== Product.SevenNews}
                    />
                    <StyledInset>
                        <StyledTitles>
                            <StyledHeading
                                title={videoDetails.heading}
                                autoPlayIsEnabled={isCountingDown}
                            >
                                {videoDetails.heading}
                            </StyledHeading>
                            {!compactMode && (
                                <StyledVideoMetadata
                                    duration={videoDuration}
                                    source={videoDetails.source}
                                    type={videoDetails.videoType}
                                />
                            )}
                        </StyledTitles>
                        {isCountingDown && (
                            <StyledAutoplayWrap>
                                <StyledCountdown>
                                    Video will play in{' '}
                                    <StyledCountdownTime>
                                        {autoplayRemainingTime}
                                    </StyledCountdownTime>
                                </StyledCountdown>
                                <StyledCancel
                                    className="video-js__autoplay-control"
                                    type="button"
                                    onClick={cancelAutoplay}
                                >
                                    Stop Autoplay
                                </StyledCancel>
                            </StyledAutoplayWrap>
                        )}
                    </StyledInset>
                </StyledTitleOverlay>
            )}
        />
    )
}
TitleOverlay.displayName = 'TitleOverlay'
